import { render, staticRenderFns } from "./addRelease.vue?vue&type=template&id=4eb4bb24"
import script from "./addRelease.vue?vue&type=script&lang=js"
export * from "./addRelease.vue?vue&type=script&lang=js"
import style0 from "./addRelease.vue?vue&type=style&index=0&id=4eb4bb24&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports